import { cn } from "@/lib/utils";
import { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLDivElement>;
const Footer = ({ className }: Props) => {
  return (
    <footer className="w-full">
      <div className={cn("flex h-20 items-center justify-center border-t", className)}>
        <p className="text-xs text-gray-600">© NEXON Korea Corporation All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
